<template>
  <CardModal
    name="unlimited-trial"
    title="Love Unlimited Swaps?"
    image-url="https://d2ezpplblfgpjx.cloudfront.net/onboarding/dreamCloset.png"
    @closed="dismissUnlimitedTrialModal">
    <template #text>
      <div>
        <p>Starting on {{ dateString }}, your <b>free unlimited swaps</b> trial is ending.</p>
        <p>Your <b>{{ planName }}</b> includes one new case each month.</p>
        <p>Upgrade now to keep the flexibility of unlimited swaps!</p>
      </div>
    </template>
    <template #primary-button="{ buttonClass }">
      <BaseButton
        tracking-name="Upgrade Now"
        text="Upgrade Now!"
        :to="{ name: 'confirm-plan-change', query: { planId: unlimitedPlan?.id } }"
        :class="buttonClass"
        @click="dismissUnlimitedTrialModal"/>
    </template>
    <template #secondary-button="{ buttonClass }">
      <BaseButton
        tracking-name="Prepay Options"
        text="Prepay Options"
        variant="secondary"
        :to="{ name: 'prepay' }"
        :class="buttonClass"
        @click="dismissUnlimitedTrialModal"/>
    </template>
    <template #bottom-button="{ buttonClass }">
      <BaseButton
        tracking-name="Keep My Plan"
        text="Keep My Plan"
        variant="text-link"
        :class="buttonClass"
        @click="declineUnlimitedTrialUpgrade"/>
    </template>
  </CardModal>
</template>

<script setup>
import CardModal from '@/components/modals/CardModal.vue'
import { useUnlimitedTrialStore } from '@/stores/unlimitedTrial.js'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import { usePlans } from '@shared/composables/plans.js'
import { useClientStore } from '@shared/stores/client.js'
import { storeToRefs } from 'pinia'
import { computed, onMounted } from 'vue'

const unlimitedTrial = useUnlimitedTrialStore()
const { unlimitedTrialEndDate } = storeToRefs(unlimitedTrial)
const {
  dismissUnlimitedTrialModal,
  declineUnlimitedTrialUpgrade,
} = unlimitedTrial
const { plans } = storeToRefs(useClientStore())
const { unlimitedPlan, initializeMembershipPlans } = usePlans()

const dateString = computed(() => (unlimitedTrialEndDate.value ?? new Date())?.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }))
const planName = computed(() => {
  const displayName = plans.value.currentBasePlan?.displayName.toLowerCase()
  return displayName.endsWith('plan') ? displayName : `${displayName} plan`
})

onMounted(() => {
  initializeMembershipPlans()
})
</script>
